<div id="mySidenav" class="sidenav" [ngClass]="{'menumobile-a': this.menuMobile}">
  <a *ngFor="let module of this.moduleData; let i = index">
    <a *ngIf="module.status=='True' && module.name!='Home' &&  module.type==this.type">
      <a class="m-menubar vcenter menu-txt-d"
        [ngClass]="this.tabActive==module.name ? 'm-menubar important vcenter w menu-txt-d' : 'm-menubar vcenter w menu-txt-d'"
        (click)="this.gotTo(module.path)" *ngIf="module.child==null || module.child==undefined || module.child.length==0">
        <span class="tabcell">
          {{module.name}}
          <i class="fa fa-ale-right" aria-hidden="true"></i>
        </span>
      </a>
      <a class="m-menubar vcenter w menu-txt-d" [ngClass]="this.tabActive==module.name ? 'm-menubar important vcenter w menu-txt-d' : 'm-menubar vcenter w menu-txt-d'" [attr.data-target]="'#tabm_'+i" data-toggle="collapse" *ngIf="module.child!=null && module.child!=undefined && module.child.length!=0">
        <span class="tabcell pointer">
          {{module.name}}
          <i data-toggle="collapse" class="fa fa-angle-right" [attr.data-target]="'#tabm_'+i"></i>
        </span>
      </a>
      <div id="tabm_{{i}}" class="collapse" *ngIf="module.status=='True' && module.child!=null && module.child!=undefined && module.child.length!=0">
        <a *ngFor="let submodule of module.child; let i = index">
          <a class="m-menuin vcenter menu-txt-c" (click)="this.gotTo(submodule.path)" *ngIf="submodule.id==1 && submodule.status=='True'">
            <span class="tabcell bold">
               {{submodule.name}} <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </a>
          <a class="m-menuin vcenter menu-txt-c" (click)="this.gotTo(submodule.path)" *ngIf="submodule.id>1 && submodule.status=='True' && this.global.activeNavigation==true">
            <span class="tabcell ">
             {{submodule.name}} <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </a>
          <a class="m-menuin vcenter menu-txt-c" *ngIf="submodule.id>1 && submodule.status=='True' && this.global.activeNavigation==false" (click)="closeMenu();this.messageUpdate()">
            <span class="tabcell ">
             {{submodule.name}} <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </a>
        </a>
        <a (click)="logout()" ui-sref="login" class="m-menuin lastlink vcenter" *ngIf="module.name=='Perfil'">
          <span class="tabcell pointer">
            Cerrar Sesi&oacute;n <i class="fa fa-times-circle" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </a>
  </a>
</div>
<!-- [END MENU MOVIL] -->
<div class="basicrow">
  <div class="htopbar ">
    <div class="container vcenter">
      <div class="tabcell">
        <div class="autorow pull-left">
          <div class="autorow pull-left d-twlv arrw">
            <select>
              <option>
                Personas
              </option>
            </select>
          </div>
          <div class="autorow pull-left h-twlv mob-size">
            <a class="on">Personas</a>
            <a class="m-sides" href="#">Negocios</a>
            <a href="https://empresas.claropr.com/" target="_blank" rel="noopener noreferrer">Empresas</a>
          </div>
        </div>
        <div class="autorow pull-right">
          <div class="chatMovil1" (click)="this.chat();">
            <img class="atenicon" width="100%" src="../../assets/images/atenicon2.png">
            Chat
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="menubar" *ngIf="this.session!='true'">
    <div class="container">
      <div class="autorow text-center">
        <a class="mc-logo center" (click)="this.gotTo('home')" *ngIf=" this.global.activeNavigation==true">
          <span class="autocont vcenter">
            <span class="tabcell">
              <img width="100%" src="../../assets/images/miclaro-logo.png">
            </span>
          </span>
        </a>
        <a class="mc-logo center" *ngIf="this.global.activeNavigation==false">
          <span class="autocont vcenter">
            <span class="tabcell">
              <img width="100%" src="../../assets/images/miclaro-logo.png">
            </span>
          </span>
        </a>
      </div>
      <div class="autorow pull-right">
        <div class="chatMovil1">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="this.session=='true'" class="menubar" id="accordion">
    <div class="container rel">
      <div class="autorow pull-left">
        <a class="mc-logo mcenter" (click)="this.gotTo('home')" *ngIf="this.global.activeNavigation==true">
          <span class="autocont vcenter">
            <span class="tabcell">
              <img width="100%" src="../../assets/images/miclaro-logo.png">
            </span>
          </span>
        </a>
        <a class="mc-logo mcenter" *ngIf="this.global.activeNavigation==false">
          <span class="autocont vcenter">
            <span class="tabcell">
              <img width="100%" src="../../assets/images/miclaro-logo.png">
            </span>
          </span>
        </a>
      </div>
      <div class="autorow pull-left visible-web">
        <span *ngFor="let module of this.moduleData; let i = index">
          <span *ngIf="module.status=='True' && module.name!='Perfil' && module.name!='Home' &&  module.type==this.type && this.global.activeNavigation==true">
            <a class="menu-ls menu-txt-d mexpand" [routerLink]="module.child==null || module.child==undefined || module.child.length==0 ? module.path : []" [ngClass]="this.tabActive==module.name ? 'menu-ls menu-txt-d on mexpand' : 'menu-ls menu-txt-d mexpand'" data-toggle="collapse" (click)="closeMenu()" [attr.data-target]="'#tab_'+i">
              <span class="autocont vcenter">
                <span class="tabcell pointer">
                  {{module.name}}
                </span>
              </span>
            </a>
          </span>
          <span *ngIf="module.status=='True' && module.name!='Perfil' && module.name!='Home' &&  module.type==this.type && this.global.activeNavigation==false">
            <a class="menu-ls menu-txt-d mexpand" [ngClass]="this.tabActive==module.name ? 'menu-ls menu-txt-d on mexpand' : 'menu-ls menu-txt-d mexpand'" data-toggle="collapse" (click)="closeMenu();this.messageUpdate()" [attr.data-target]="'#tab_'+i">
              <span class="autocont vcenter">
                <span class="tabcell pointer">
                  {{module.name}}
                </span>
              </span>
            </a>
          </span>
        </span>
      </div>
      <div class="autorow pull-right visible-movil">
        <div class="mnu-icon">
          <div class="autocont vcenter">
            <div class="tabcell">
              <i (click)="showMenuMobile()" class="fa fa-bars" aria-hidden="true"></i>
              <i (click)="showMenu()" class="fa fa-times" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-segundario" *ngFor="let module of this.moduleData; let i = index">
        <div *ngIf="module.name=='Perfil' && module.type=='postpaid'">
          <div class="menu3">
            <div class="tabcell menu2"
              [ngStyle]="{'background':this.showMenuStatus === true ? '#fff' : '#ef3829','color':this.showMenuStatus === true ? '#ef3829' : '#fff' }"
              data-toggle="collapse" [attr.data-target]="'#tab_'+i" (click)="showMenu()">
              <span>Hola, {{this.userName}}
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </div>
            <div class="icono-menu"
              [ngStyle]="{'border-right':this.showMenuStatus === true ? '0px solid' : ' 1px solid','padding-top':this.notificationsCounter > 0 ? '0px' :' 10px' }">
              <div data-toggle="collapse" data-target="#tab" class="notifc pointer ajusteNroNot"
                *ngIf="this.notificationsCounter>0">
                   {{this.notificationsCounter}}
              </div>
              <div id="tab" class="collapse">
                <div class="notifpopover">
                  <img class="ntf-tr" width="100%" src="/assets/images/ntf-triangle.png">
                  <ng-container *ngFor="let notification of this.notifications; let i = index">
                    <ng-container *ngIf="notification.length!=0">
                      <div (click)="this.goMessage(i)" class="ntfboard vcenter">
                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                        <div class="tabcell">
                          {{notification.subject}}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <a (click)="this.goMessage(-1)" class="ntfseemore">
                    Ver todas las notificaciones&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <i data-toggle="collapse" data-target="#tab" class="fa fa-user pointer ajusteIconNot"
                aria-hidden="true"></i>
            </div>
          </div>
          <div class="menu-b" [ngStyle]="{'display':this.showMenuStatus === true ? 'block' : 'none' }">
            <a *ngFor="let submodule of module.child; let i = index">
              <a (click)="this.gotTo(submodule.path)" class="acc-links vcenter2"
                *ngIf="module.status=='True' && submodule.status=='True'">
                <span class="tabcell menu-b">
                  <span class="">{{submodule.name}}</span>
                  <span class="fa-rigth"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                </span>
              </a>
            </a>
            <a (click)="logout()" class="acc-links vcenter2 pointer">
              <span class="tabcell menu-b">
                <span class="">Cerrar Sesi&oacute;n</span>
                <span class="fa-rigth"><i class="fa fa-times-circle" aria-hidden="true"></i></span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let module of this.moduleData; let i = index" class="panel-group">
      <div id="tab_{{i}}" class="collapse claro-sublinks" data-parent="#accordion"
        [hidden]="module.name=='Perfil'||module.name=='Home'||module.child==null || module.child==undefined || module.child.length==0 "
        *ngIf="module.status=='True'">
        <div class="subconts">
          <div class="basicrow roboto-m f-black f-bmed" *ngFor="let submodule of module.child; let i = index">
            <a *ngIf="i==0 && submodule.status=='True' && submodule.name!='Tienda' && this.global.activeNavigation==true"
            (click)="this.gotTo(submodule.path)" class="menu-txt-c cursor">
              {{submodule.name}}
            </a>
            <a *ngIf="i==0 && submodule.status=='True' && submodule.name=='Tienda' && this.global.activeNavigation==true"   (click)="this.gotTo(submodule.path)" 
            class="menu-txt-c cursor">
              {{submodule.name}}
            </a>
            <a *ngIf="i==0 && submodule.status=='True' && this.global.activeNavigation==false" class="menu-txt-c cursor" (click)="closeMenu();this.messageUpdate()">
              {{submodule.name}}
            </a>
          </div>
          <div class="basicrow roboto-r f-black f-med">
            <img class="submenu-icon" width="100%" src="../../assets/images/ico_manejoRecursos.svg"
              *ngIf="module.name=='Manejo de Cuenta'">
            <img class="submenu-icon" width="100%" src="../../assets/images/ico_resumen_de_factura-empresa-01.svg"
              *ngIf="module.name=='Pagos y Facturas'">
            <img class="submenu-icon" width="100%" src="../../assets/images/menu-icon-i.png"
              *ngIf="module.name=='Factura y Pago'">
            <img class="submenu-icon" width="100%" src="../../assets/images/menu-icon-ii.png"
              *ngIf="module.name=='Mi Consumo'">
            <img class="submenu-icon" width="100%" src="../../assets/images/menu-icon-iii.png"
              *ngIf="module.name=='Mis Equipos y Servicios'">
            <img class="submenu-icon" width="100%" src="../../assets/images/menu-icon-iv.png"
              *ngIf="module.name=='Compras'">
            <a *ngFor="let submodule of module.child; let i = index">
              <a *ngIf="i!=0 && submodule.status=='True' && this.global.activeNavigation==true" class="autorow m-top-ii pull-left m-right-i menu-txt-c cursor"
              (click)="this.gotTo(submodule.path)">
                {{submodule.name}}
              </a>
              <!--
              <a *ngIf="i!=0 && submodule.status=='True' && submodule.name=='Tienda' && this.global.activeNavigation==true" class="autorow m-top-ii pull-left m-right-i menu-txt-c cursor" href='{{submodule.path}}' target='_blank' rel="noopener noreferrer">
                   {{submodule.name}}
              </a>
              -->
              <a *ngIf="i!=0 && submodule.status=='True' && this.global.activeNavigation==false" class="autorow m-top-ii pull-left m-right-i menu-txt-c cursor" (click)="closeMenu();this.messageUpdate()">
                {{submodule.name}}
              </a>
            </a>
          </div>
        </div>
        <div class="bluemenumsg roboto-r vcenter">
          <div class="tabcell">
            La red donde todo es posible
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="basicrow m-top-ii m-bott-i f-black f-lsemi roboto-l visible-sm visible-movil" *ngIf="this.session=='true' && this.showUserMobile == true">
  <div class="container ng-binding hiAdvice">Hola, {{this.userName}}</div>
</div>
